import React, { useState, useEffect } from "react";

// material import
import { Box, Card, CircularProgress, Grid2, Typography } from "@mui/material";
import AdminDBServices from "../../services/v1/adminDBServices";

const AmountsDetails = () => {
  const [donationAmountValue, setDonationAmountValue] = useState(null);
  const [donorAmountValue, setDonorAmountValue] = useState(null);

  useEffect(() => {
    const fetchAmounts = async () => {
      try {
        const donationRes = await AdminDBServices.donationAmount();
        const donorRes = await AdminDBServices.donorAmount();

        if (donationRes && donationRes.data) {
          setDonationAmountValue(donationRes.data.data.total_amount);
        }

        if (donorRes && donorRes.data) {
          setDonorAmountValue(donorRes.data.data.total_donors);
        }
      } catch (error) {
        console.error("Error fetching donation and donor amounts", error);
      }
    };

    fetchAmounts();
  }, []);

  return (
    <Grid2 container>
      <Grid2 size={{ xs: 12 }}>
        <Card sx={{ height: 140 }}>
          <Box p={3}>
            <Typography variant="h5" sx={{ fontSize: 18, color: "grey" }}>
              Donations
            </Typography>
            <Typography variant="h5" fontWeight="bold" align="center" mt={1}>
              {donationAmountValue ? (
                `Rs ${new Intl.NumberFormat("en-US", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(donationAmountValue)}`
              ) : (
                <CircularProgress size="30px" color="secondary" />
              )}
            </Typography>
          </Box>
        </Card>
      </Grid2>
      <Grid2 size={{ xs: 12 }} mt={2}>
        <Card sx={{ height: 140 }}>
          <Box p={3}>
            <Typography variant="h5" sx={{ fontSize: 18, color: "grey" }}>
              Donors
            </Typography>
            <Typography variant="h5" fontWeight="bold" align="center" mt={1}>
              {donorAmountValue ? (
                `${donorAmountValue}+`
              ) : (
                <CircularProgress size="30px" color="secondary" />
              )}
            </Typography>
          </Box>
        </Card>
      </Grid2>
    </Grid2>
  );
};

export default AmountsDetails;
